import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import MaterialLink from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { AccountPaperContainer } from '@themes/account/components';
import MaterialLogoutIcon from '@mui/icons-material/Logout';
export const LinkItem = styled(Link)(({ theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        padding: theme.spacing(1),
        color: (_b = (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.text,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        '--icon-color': (_d = (_c = theme.account) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.text,
        '&:hover,&.active': {
            color: '#000',
            backgroundColor: '#fff',
            '--icon-color': (_f = (_e = theme.account) === null || _e === void 0 ? void 0 : _e.navigation) === null || _f === void 0 ? void 0 : _f.background,
        },
        '&.mobile:not(:last-child)': {
            borderBottom: `1px solid ${(_h = (_g = theme.account) === null || _g === void 0 ? void 0 : _g.navigation) === null || _h === void 0 ? void 0 : _h.text}`,
        },
        '&.edit-page': {
            marginTop: theme.spacing(6),
        },
    });
});
export const MaterialLinkItem = styled(MaterialLink)(({ theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        padding: theme.spacing(1),
        color: (_b = (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.text,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        '--icon-color': (_d = (_c = theme.account) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.text,
        '&:hover,&.active': {
            color: '#000',
            backgroundColor: '#fff',
            '--icon-color': (_f = (_e = theme.account) === null || _e === void 0 ? void 0 : _e.navigation) === null || _f === void 0 ? void 0 : _f.background,
            textextDecoration: 'none',
        },
        '&.mobile:not(:last-child)': {
            borderBottom: `1px solid ${(_h = (_g = theme.account) === null || _g === void 0 ? void 0 : _g.navigation) === null || _h === void 0 ? void 0 : _h.text}`,
        },
    });
});
export const LinkItemIcon = styled('img')(({ theme }) => ({
    marginRight: theme.spacing(1),
    height: 30,
    width: 30,
}));
export const LinkItemSvgIcon = styled('span')(({ theme }) => ({
    marginRight: theme.spacing(1),
    height: 30,
    width: 30,
    '& svg': {
        height: 30,
        width: 30,
    },
}));
export const LogoutIcon = styled(MaterialLogoutIcon)(({ theme }) => ({
    marginRight: theme.spacing(1),
    height: 30,
    width: 30,
}));
export const NavigationWrapper = styled((props) => _jsx(AccountPaperContainer, Object.assign({}, props)))(({ theme }) => {
    var _a, _b;
    return ({
        marginRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        backgroundColor: (_b = (_a = theme.account) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.background,
        '&.mobile': {
            marginRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
        },
    });
});
export const IconLoader = (props) => {
    const [rendered, setRendered] = useState(null);
    useEffect(() => {
        if (!rendered && props.src.includes('.svg')) {
            fetch(props.src)
                .then((svg) => svg.text())
                .then((svg) => {
                setRendered(svg);
            });
        }
    }, [props.src, rendered]);
    return rendered ? (_jsx(LinkItemSvgIcon, { dangerouslySetInnerHTML: { __html: rendered }, className: clsx({
            active: props.active,
        }), "ariea-label": props.alt })) : (_jsx(LinkItemIcon, { src: props.src, "ariea-label": props.alt }));
};
